// extracted by mini-css-extract-plugin
module.exports = {"cls1":"HomePage-CssProp11_td-module--cls1--LNYcW","cls2":"HomePage-CssProp11_td-module--cls2--Av7Fz HomePage-CssProp11_td-module--cls1--LNYcW"};